'use client';

import { motion } from 'framer-motion';
import type { PromptFormulaSectionData } from '../../types';
import { PortableTextContent } from '../PortableTextContent';
import { SectionShell, staggerContainer, staggerItem } from '../section-shared';

export function PromptFormulaSection({ section }: { section: PromptFormulaSectionData }) {
  const items = section.items ?? [];

  return (
    <SectionShell>
      <div className="w-full">
        <h2 className="font-semibold text-[40px] text-white leading-tight sm:text-[32px]">{section.title}</h2>
        {section.description && section.description.length > 0 && (
          <PortableTextContent className="mt-4 text-base leading-[1.6] sm:text-sm" value={section.description} />
        )}
        <motion.div
          className="mt-12 flex flex-col gap-10 border-white/25 border-l-[3px] pl-10 sm:mt-8 sm:gap-6 sm:pl-6"
          initial="hidden"
          variants={staggerContainer}
          viewport={{ once: true, margin: '-60px' }}
          whileInView="visible"
        >
          {items.map((item) => (
            <motion.div key={item._key || item.title} variants={staggerItem}>
              <h3 className="mb-3 font-semibold text-white text-xl leading-[1.3] sm:text-lg">{item.title}</h3>
              <PortableTextContent
                className="whitespace-pre-line text-base leading-[1.6] sm:text-sm"
                value={item.description}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </SectionShell>
  );
}
